import Translate from '../../../Src/Modules/Localization/Translate';

export default {
    install: (app, options) => {
        app.config.globalProperties.$t = (key, replacements) => {
            return Translate(key, replacements);
        };
    }
};
